import React from "react";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown";
import styles from "./styles.module.css";

const InputWithSelect = ({
  label,
  value,
  onChange,
  placeholder,
  error,
  selectOptions = [],
  selectValue,
  onSelectChange,
  selectPlaceholder = "Select...",
  disabled,
  id,
  className,
}) => {
  return (
    <div className={`${styles.container} ${className || ""}`.trim()}>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.row}>
        <div className={styles.inputSlot}>
          <input
            id={id}
            type="text"
            className={`${styles.input} ${error ? styles.inputError : ""}`.trim()}
            value={value != null ? String(value) : ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            disabled={disabled}
            aria-invalid={!!error}
            aria-describedby={error ? `${id}-error` : undefined}
          />
        </div>
        <div className={styles.dropdownSlot}>
          <Dropdown
            options={selectOptions}
            value={selectValue}
            onChange={onSelectChange}
            placeholder={selectPlaceholder}
            disabled={disabled}
            aria-label={label ? `${label} unit` : "Unit"}
            className={styles.dropdown}
            triggerClassName={styles.triggerMerged}
          />
        </div>
      </div>
      {error && (
        <span id={id ? `${id}-error` : undefined} className={styles.errorMessage}>
          {error}
        </span>
      )}
    </div>
  );
};

InputWithSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  selectValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelectChange: PropTypes.func.isRequired,
  selectPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default InputWithSelect;
